import * as React from "react";
import { useLocation, useNavigate } from "react-router";
function DownloadResourcesButton() {
  return (
    ""
    // <a href="/assets/Nirantara_Brochure.pdf" target="_blank" download className="justify-center self-start px-4 py-3.5 mt-5 text-sm leading-5 text-right bg-white border-2 border-white border-solid rounded-[60px] text-stone-900">
    //   Download Resources
    // </a>
  );
}

function LinkRenderer({ link, full_width }) {
  const navigate = useNavigate()
  const path = useLocation().pathname

  return (
    <li  >
      <span
        className={` cursor-pointer`}

        onClick={() => {
          if (link?.link) {
            navigate(link.link)
            console.log(link.link, path)
            if (path === link.link) {
              window.location.reload()
            }
          }
        }}
      >
        {link?.title}
      </span>
    </li>
  )
}
function AboutNirantara() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col text-white max-md:mb-8">
      <h2 className="mb-4 text-lg font-bold leading-6 text-white">
        About Nirantara
      </h2>
      <p className="mb-6 text-sm leading-6">
        Nirantara empowers organisations with innovative, profitable approaches to sustainability and ESG. We deliver actionable strategies that help businesses thrive while creating a positive impact on society and the planet.
      </p>
      <button
        onClick={() => navigate('/about-us')}
        className="self-start px-6 py-3 text-sm font-semibold bg-white text-stone-900 rounded-[60px] hover:bg-gray-100 transition-colors duration-300 mb-6"
      >
        Learn More
      </button>
      <div className="flex items-center gap-6">
        <a
          href="https://www.linkedin.com/company/nirantara-ecoventures/"
          target="_blank"
          className="transition-opacity hover:opacity-80"
        >
          <img alt="LinkedIn" src="/assets/icons/linkedin.svg" className="w-6 h-6" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61551552543080"
          target="_blank"
          className="transition-opacity hover:opacity-80"
        >
          <img alt="Facebook" src="/assets/icons/facebook.svg" className="w-6 h-6" />
        </a>
        <a
          href="https://instagram.com/nirantara_ecoventures?igshid=MzRlODBiNWFlZA=="
          target="_blank"
          className="transition-opacity hover:opacity-80"
        >
          <img alt="Instagram" src="/assets/icons/instagram.svg" className="w-6 h-6" />
        </a>
      </div>
    </div>
  );
}

function FooterLinks() {
  const navigate = useNavigate();

  const companyLinks = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Resources",
      link: "/resources",
    },
    {
      title: "Blogs",
      link: "/blogs",
    },
    {
      title: "Careers",
      link: "/career",
    },
    {
      title: "Our Team",
      link: "/our-team",
    },
  ];

  const menuLinks = [
    {
      title: "Nirantara Journey",
      link: "/about-us",
    },
    {
      title: "Memberships and Partnerships",
      link: "/membership-and-partnership",
    },
    {
      title: "Certification",
      link: "/certification",
    },
    {
      title: "Event and Gallery",
      link: "/event-gallery",
    },
  ];

  const connectLinks = [
    {
      title: "Connect with us",
      link: "/contact-us",
    }
  ]

  return (
    <div className="grid grid-cols-3 gap-8 max-md:gap-4">
      {/* Company Section */}
      <div className="flex flex-col">
        <h3 className="mb-4 text-lg font-bold text-white">Company</h3>
        <ul className="flex flex-col space-y-3">
          {companyLinks.map((link, index) => (
            <li key={index}>
              <span
                className="text-sm text-white transition-colors cursor-pointer hover:text-gray-300"
                onClick={() => {
                  if (link?.link) {
                    navigate(link.link);
                  }
                }}
              >
                {link.title}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Menu Section */}
      <div className="flex flex-col">
        <h3 className="mb-4 text-lg font-bold text-white">Menu</h3>
        <ul className="flex flex-col space-y-3">
          {menuLinks.map((link, index) => (
            <li key={index}>
              <span
                className="text-sm text-white transition-colors cursor-pointer hover:text-gray-300"
                onClick={() => {
                  if (link?.link) {
                    navigate(link.link);
                  }
                }}
              >
                {link.title}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact Section */}
      <div className="flex flex-col">
        <h3 className="mb-4 text-lg font-bold text-white">Contact us</h3>
        <ul className="flex flex-col space-y-3">
          {connectLinks.map((link, index) => (
            <li key={index}>
              <span
                className="text-sm text-white transition-colors cursor-pointer hover:text-gray-300"
                onClick={() => {
                  if (link?.link) {
                    navigate(link.link);
                  }
                }}
              >
                {link.title}
              </span>
            </li>
          ))}
          <li>
            <a
              href="mailto:sustainable@nirantara.solutions"
              className="text-sm text-white transition-colors hover:text-gray-300"
            >
              sustainable@nirantara.solutions
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

function Footer() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center helvetica">
      <div className="flex flex-col items-center w-full px-16 pt-20 pb-8 bg-neutral-800 max-md:px-6 max-md:pt-12 max-md:pb-8">
        <div className="flex flex-col mt-2 w-full max-w-[1290px]">
          {/* Header Section */}
          <header className="flex gap-5 font-bold max-md:flex-col max-md:gap-4">
            <h2 className="flex-auto text-3xl leading-10 text-white max-md:text-2xl max-md:leading-8">
              Towards a Sustainable Future, One Step at a Time
            </h2>
            <DownloadResourcesButton />
          </header>

          {/* Divider */}
          <hr className="h-px border border-solid shrink-0 mt-14 bg-zinc-200 border-zinc-200 max-md:mt-8" />

          {/* Main Content */}
          <main className="mt-16 max-md:mt-8">
            <div className="flex justify-between gap-8 max-md:flex-col max-md:gap-8">
              {/* About Section */}
              <div className="flex flex-col w-[45%] max-md:w-full">
                <AboutNirantara />
              </div>

              {/* Links Section */}
              <div className="flex flex-col w-[43%] max-md:w-full">
                <FooterLinks />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Footer;
